import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const AutomatchingDelayWarning = () => {
  const { t } = useTranslation("order");
  return (
    <Typography color="error" fontSize={14}>
      {t(`order:automatchingDelayTooLong`)}
    </Typography>
  );
};
